import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface CtaButtonsProps {
  primaryButtonText: string
  isDismissable?: boolean
  onPrimaryButtonClick: () => void
  onSkipClick?: () => void
}

const CtaButtons: React.FC<CtaButtonsProps> = ({
  primaryButtonText,
  isDismissable = false,
  onPrimaryButtonClick,
  onSkipClick,
}) => {
  const shouldRenderSkipButton = isDismissable && onSkipClick
  return (
    <Box flexDirection="row" justifyContent="flexStart" gap="s8">
      {shouldRenderSkipButton && (
        <Button type="secondary" onClick={onSkipClick} iconName="cross">
          {i18n.t('expenses_v2.cards.blocks.require_onboarding.not_now')}
        </Button>
      )}
      <Button
        type="positive"
        onClick={onPrimaryButtonClick}
        iconName={shouldRenderSkipButton && 'check'}
      >
        {primaryButtonText}
      </Button>
    </Box>
  )
}

export default CtaButtons
